"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlContainer = exports.Caption = exports.Label = void 0;

var _index = require("../styles/index.js");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Label = (0, _index.styled)('label', function (props) {
  var $disabled = props.$disabled,
      _props$$theme = props.$theme,
      colors = _props$$theme.colors,
      sizing = _props$$theme.sizing,
      typography = _props$$theme.typography;
  return _objectSpread({}, typography.font350, {
    fontWeight: 500,
    color: $disabled ? colors.foregroundAlt : colors.foreground,
    cursor: $disabled ? 'not-allowed' : 'auto',
    display: 'block',
    paddingTop: '0',
    paddingRight: '0',
    paddingBottom: '0',
    paddingLeft: '0',
    marginTop: sizing.scale300,
    marginRight: '0',
    marginBottom: sizing.scale300,
    marginLeft: '0'
  });
});
exports.Label = Label;
Label.displayName = "Label";
var Caption = (0, _index.styled)('div', function (props) {
  var $error = props.$error,
      _props$$theme2 = props.$theme,
      colors = _props$$theme2.colors,
      sizing = _props$$theme2.sizing,
      typography = _props$$theme2.typography;
  return _objectSpread({}, typography.font200, {
    color: $error && typeof $error !== 'boolean' ? colors.negative400 : colors.foregroundAlt,
    paddingTop: '0',
    paddingRight: '0',
    paddingBottom: '0',
    paddingLeft: '0',
    marginTop: sizing.scale300,
    marginRight: '0',
    marginBottom: sizing.scale300,
    marginLeft: '0'
  });
});
exports.Caption = Caption;
Caption.displayName = "Caption";
var ControlContainer = (0, _index.styled)('div', function (props) {
  var sizing = props.$theme.sizing;
  return {
    marginBottom: sizing.scale600
  };
});
exports.ControlContainer = ControlContainer;
ControlContainer.displayName = "ControlContainer";